export default __webpack_public_path__ + "static/media/suite-montanha1-5.895a1cba.webp";